module.exports = __webpack_public_path__ + "media/images/photo01-5f9f4ec9a11312dfa5c7836fc8abb419.png";